import * as React from 'react';

function IconChevronDown(props) {
  return (
    <svg width="16px" height="16px" viewBox="2 2 14 14" fill="none" {...props}>
      <path
        d="M9.5 11.625a.75.75 0 01-.532-.218l-3-3a.753.753 0 111.065-1.065L9.5 9.825l2.475-2.385a.75.75 0 111.035 1.08l-3 2.895a.75.75 0 01-.51.21z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoIconChevronDown = React.memo(IconChevronDown);
export default MemoIconChevronDown;
